<template>
  <div class="connecting" :class="{'light': theme === 'light'}">
    <div />
    <div />
    <div />
    <div />
  </div>
</template>

<script>

export default {
  props: {
    theme: {
      type: String,
      default: 'dark',
    },
  },
}
</script>

<style lang="scss" scoped>
  .connecting {
    display: flex;
    gap: 8px; /* Khoảng cách giữa các thanh */
    position: relative;
    width: 20px;
    height: 12px;
  }

  .connecting {
    div {
      width: 3px;
      height: 8px;
      border-radius: 4px;
      position: absolute;
      bottom: 0;
      animation: connecting-animation 1.2s infinite ease-in-out;
      --bg-inactive: rgba(240, 244, 250, 0.7);
      --bg-active: #fff;

      &:nth-child(1) {
        animation-delay: 0s;
      }
      &:nth-child(2) {
        animation-delay: 0.2s;
        left: 5px;
      }
      &:nth-child(3) {
        animation-delay: 0.4s;
        left: 10px;
      }
      &:nth-child(4) {
        animation-delay: 0.6s;
        left: 15px;
      }
    }
    &.light {
      div {
        --bg-inactive: rgba(10, 10, 10, 0.2);
        --bg-active: rgba(10, 10, 10, 0.4);
      }
    }
  }

  @keyframes connecting-animation {
    0% {
      height: 12px;
      background-color: var(--bg-active);
    }
    20% {
      height: 6px;
      background-color: var(--bg-inactive);
    }
    80% {
      height: 6px;
      background-color: var(--bg-inactive);
    }
    100% {
      height: 12px;
      background-color: var(--bg-active);
    }
  }
</style>
